import { BrowserModule } from '@angular/platform-browser';
import { APP_INITIALIZER, LOCALE_ID, NgModule } from '@angular/core';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import {
	AutenticacionGoogle,
	ConfAutentificacionGoogle
} from '@copec-gid/copec-one.backoffice-web-security-authentication-module';
import { HTTPService } from '@copec-gid/copec-one.backoffice-web-security-authorization-module';
import { HTTPService as HTTPServiceForUtils } from '@copec-gid/gid-arquitectura.seguridad-autorizacion-modulo';
import { GidLoggerModule } from '@copec-gid/gid-arquitectura.console-log';
import {
	ConfProyecto,
	InterceptorCopecService,
	SplashScreenService,
	ToastsContainer
} from '@copec-gid/gid-arquitectura.utilitarios-base-modulo-a16';
import { TranslateLoader, TranslateModule } from '@ngx-translate/core';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './core/inicial-componente/app.component';
import { ErrorPageComponent } from './views/pages/error-page/error-page.component';
import { HIGHLIGHT_OPTIONS } from 'ngx-highlightjs';
import { LayoutModule, ThemeModule, ThemeService } from '@copec-gid/copec-one.backoffice-web-default-theme/left-light';
import { HTTP_INTERCEPTORS, HttpClient, HttpClientModule } from '@angular/common/http';
import { PageWaitComponent } from './core/inicial-componente/page-wait/page-wait.component';
import { environment } from 'src/environments/environment';
import { registerLocaleData } from '@angular/common';
import localeEsCl from '@angular/common/locales/es-CL';


function aplicarSesionConfProyectoDesdeAlmacenLocal(): void {
  ConfProyecto.session_key = localStorage.getItem('session_key') || '';
  ConfProyecto.session_token = localStorage.getItem('session_token') || '';
}

function initSingletonHTTPService(
  httpService: HTTPService,
  httpServiceForUtils: HTTPServiceForUtils,
  autenticacionGoogle: AutenticacionGoogle,
  splash: SplashScreenService,
	themeService: ThemeService) {
  return () => {
    return new Promise<void>(async (resolve) => {
      (window as any).splashGeneral = () => splash;
      HTTPService.instance = httpService;
      HTTPServiceForUtils.instance = httpServiceForUtils;
      ConfProyecto.init({
        urlMenu: environment.URL_LOGOUT,
        urlLogout: environment.URL_LOGOUT,
        nombreAplicacion: 'Backoffice',
        pathPaginaPrincipal: '/app/principal',
        pathLogin: '/auth-google/login',
        public_key: environment.public_key,
        apiUrlEnvironment: environment.API_URL,
        application_id: environment.APPLICATION_ID,
        shopUrlEnvironment: environment.PAYOUT_URL,
        checkoutUrlEnvironment: environment.TRANSACTION_URL,
        adminUrlEnvironment: environment.HUB_URL,
      });
      ConfProyecto.menu_items_copec = {
        accounts: {
          name: 'Cuentas',
          icon: 'user',
          menus: {
            'dealer/list': {
              name: 'Concesionarios'
            },
            'merchant/list': {
              name: 'Comercios'
            },
            'user/list': {
              name: 'Usuarios'
            }              
          }
        },
        transactions: {
          name: 'Transacciones',
          icon: 'trending-up'
        },
        payouts: {
          name: 'Liquidaciones',
          icon: 'dollar-sign',
          menus: {
            'payout/list': {
              name: 'Liquidaciones'
            },
            'report/list': {
              name: 'Reporte'
            }
          }
        },
        reconciliations: {
          name: 'Conciliaciones',
          icon: 'minimize-2'
        }
      };
      ConfProyecto.loadLevelId();
      themeService.initTheme();
      ConfProyecto.urlImagenlogo = 'assets/images/logos/BO_logo.svg';
      ConfAutentificacionGoogle.init({
        urlOAut1Step: '/accesscontrol/authentication',
        urlOAuth2Step: '/accesscontrol/authentication/callback',
      });
      await autenticacionGoogle.activeLoginGoogle(window.location.pathname + window.location.search);
      aplicarSesionConfProyectoDesdeAlmacenLocal();
      resolve();
    });
  };
}

registerLocaleData(localeEsCl, 'es-CL');

@NgModule({
  declarations: [
    AppComponent,
    ErrorPageComponent,
    PageWaitComponent
  ],
  imports: [
    BrowserModule,
    BrowserAnimationsModule,
    LayoutModule,
    HttpClientModule,
    AppRoutingModule,
    ToastsContainer,
    ThemeModule.forRoot('one'),
		GidLoggerModule.forRoot(environment),
		TranslateModule.forRoot({
			loader: {
				provide: TranslateLoader,
				useFactory: (http: HttpClient) =>
					new TranslateHttpLoader(http, "assets/i18n/", ".json"),
				deps: [HttpClient],
			},
		}),
  ],
  providers: [
    SplashScreenService,
		HTTPService,
		HTTPServiceForUtils,
		AutenticacionGoogle,
		{
			provide: APP_INITIALIZER,
			useFactory: initSingletonHTTPService,
			multi: true,
			deps: [HTTPService, HTTPServiceForUtils, AutenticacionGoogle, SplashScreenService, ThemeService]
		},
		{
			provide: HTTP_INTERCEPTORS,
			useClass: InterceptorCopecService,
			multi: true,
		},
		{
			provide: HIGHLIGHT_OPTIONS, // https://www.npmjs.com/package/ngx-highlightjs
			useValue: {
				coreLibraryLoader: () => import('highlight.js/lib/core'),
				languages: {
					xml: () => import('highlight.js/lib/languages/xml'),
					typescript: () => import('highlight.js/lib/languages/typescript'),
					scss: () => import('highlight.js/lib/languages/scss'),
				}
			}
		},
    { provide: LOCALE_ID, useValue: 'es-CL' },
  ],
  bootstrap: [AppComponent]
})
export class AppModule {

}
